import style from "../../assets/scss/sub/miniGame.module.scss";
import bubbleTailImg from "../../assets/images/mypage/bubble_tail_icon.svg";
import {useLanguage, useModal, useUserAgent} from "../../hooks/hooks";
import {useTranslation} from "react-i18next";

export function MiniGame({ accessToken }: { accessToken: string }) {
    const { t } = useTranslation("miniGame");
    const { openConfirmModal } = useModal();
    const { isTablet, isMobile } = useUserAgent();
    const { isKorean} = useLanguage();

    // const homeBoundAnimals = () => {
    //   openAlertModal({
    //     title: "미니게임 안내",
    //     desc: "[집으로 가는 길] 미니게임은 곧 공개될 예정입니다.\n 감사합니다.",
    //   });
    // };

    const games = [
        {
            baseName: "catch_monster",
            alt: "game1",
            gameId: "catchMonster",
            url: `https://catch-monster.feel-good.io/?token=${accessToken}`
        },
        {
            baseName: "hide_and_seek",
            alt: "game2",
            gameId: "hideNSeek",
            url: `https://hide-seek.feel-good.io/?token=${accessToken}`
        },
        {
            baseName: "sound_cooking",
            alt: "game3",
            gameId: "soundCooking",
            url: `https://sound-cooking.feel-good.io/?token=${accessToken}`
        },
        {
            baseName: "animal_detector",
            alt: "game4",
            gameId: "animalDetective",
            url: `https://animal-detective.feel-good.io/?token=${accessToken}`
        },
        {
            baseName: "home_bound_animal",
            alt: "game5",
            gameId: "homeBoundAnimals",
            url: `https://home-bound-animals.feel-good.io/?token=${accessToken}`
        }
    ];

    // 이미지를 클릭했을 때 동작하는 함수
    const openGameInNewTab = (url: string) => {
        if (isTablet) {
            openConfirmModal(
                {
                    title: t('miniGame.modal.title'),
                    desc: `${t('miniGame.modal.desc1')}\n${t('miniGame.modal.desc2')}`,
                },
                () => window.open(url, "_blank")
            );
        } else if (isMobile) {
            openConfirmModal(
                {
                    title: t('miniGame.modal.title'),
                    desc: `${t('miniGame.modal.desc1')}\n${t('miniGame.modal.desc3')}\n${t('miniGame.modal.desc2')}`,
                },
                () => window.open(url, "_blank")
            );
        } else {
            window.open(url, "_blank");
        }
    };

    const handleImageClick = (gameId:string) => {
        const game = games.find(g => g.gameId === gameId);
        if (game) {
            openGameInNewTab(game.url);
        }
    };

// 이미지 렌더링 함수
    const renderGameImages = () => {
        return games.map((game, index) => (
            <img
                key={index}
                src={`https://images.feel-good.io/common/${game.baseName}${isKorean ? '' : '_en'}.png`}
                alt={game.alt}
                onClick={() => handleImageClick(game.gameId)}
                className={style.catchMonsterBannerImage}
            />
        ));
    };
    return (
        <div className={style.container}>
            <div className={style.containerContentBox}>
                <div className={style.containerTitle}>{t('miniGame.title.label')}</div>
                <div className={style.speechBubbleContainer}>
                    <div className={style.gameSpeechBubble}>{t('miniGame.title.balloon')}</div>
                    <img src={bubbleTailImg} className={style.bubbleTailImg} alt={bubbleTailImg}/>
                </div>
            </div>

            <div className={style.bannerContainer}>
                {renderGameImages()}
            </div>
        </div>
    );
}
